import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

const Header = () => {
const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  // const [showGST, setShowGST] = useState(false);

  // const [openPopup, setOpenPopup] = useState(false);
  // const [planCode, setPlanCode] = useState("");
  // const [tenantId] = useState("T6611001XT8");
  // const [isRider, setIsRider] = useState(false);
  // const [showMember, setShowMember] = useState(false);
  // const [memberCount, setMemberCount] = useState(0);

 

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    setMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 px-[5%] transition-all duration-300 ${
          scrolled
            ? "bg-white/95 backdrop-blur-md shadow-[0_1px_20px_rgba(0,0,0,0.08)]"
            : "bg-transparent"
        }`}
      >
        <div className="flex items-center justify-between h-[70px] max-w-[1200px] mx-auto">
          {/* Logo */}
          <a href="/" className="inline-block">
            <img
              src="assets/images/sugamya-finance-logo.png"
              alt="Aarogya"
              className="h-[60px] max-[375px]:h-[50px] block"
            />
          </a>

          {/* Desktop CTA */}
          <div className="hidden md:flex gap-3">
            <button
              onClick={() =>
                window.open("https://sugmyafinance.com/app", "_blank")
              }
              className="bg-gradient-to-l from-[#CC0404] via-[#5B1E3A] to-[#023365] text-white border-none py-2.5 px-5 rounded-full text-sm font-semibold cursor-pointer transition-all duration-200 hover:opacity-90 hover:-translate-y-0.5"
            >
              Login
            </button>
          </div>

          {/* Hamburger */}
          <button
            className={`md:hidden bg-transparent border-none cursor-pointer text-[26px] transition-colors duration-200 ${
              scrolled ? "text-[#0657A3]" : "text-white"
            }`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            ☰
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden bg-white border-t border-gray-200 px-5 py-4 flex flex-col gap-4 animate-fadeUp">
            {/* {["Home", "Benefits", "Plans", "Testimonials"].map((i) => (
              <button
                key={i}
                onClick={() => scrollTo(i.toLowerCase())}
                className="bg-transparent border-none cursor-pointer text-base text-[#1a1a2e] font-medium text-left font-[DM_Sans,sans-serif]"
              >
                {i}
              </button>
            ))} */}
            <button
              onClick={() =>
                window.open("https://sugmyafinance.com/app", "_blank")
              }
              className=" bg-gradient-to-l from-[#CC0404] via-[#5B1E3A] to-[#023365] text-white border-none py-3 px-8 rounded-full text-[15px] font-semibold cursor-pointer transition-all duration-200 hover:opacity-90"
            >
              Login
            </button>
          </div>
        )}
      </nav>


    </>
  );
};

export default Header;
